import { ReactNode, useEffect, useRef } from 'react';
import styles from './SelectMedia.module.css';

export interface SelectMediaCodeProps {
  onSelect: (value: string) => void
  defaultValue?: string
  disabled?: boolean
  placeholder?: string
  button: string
  description?: ReactNode
}

export function SelectMediaCode(props: SelectMediaCodeProps) {
  const {
    onSelect, button, defaultValue, placeholder, disabled, description,
  } = props;

  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textAreaRef.current?.focus();
  }, []);

  return (
    <form
      className={styles.tabContent}
      onSubmit={(e) => {
        e.preventDefault();
        const data = new FormData(e.target as HTMLFormElement);
        const code = data.get('code');
        if (code) {
          onSelect(code as string);
        }
      }}
    >
      <textarea
        ref={textAreaRef}
        name="code"
        className={styles.textArea}
        placeholder={placeholder || 'Enter code...'}
        defaultValue={defaultValue}
        disabled={disabled}
      />

      <button type="submit" className={styles.button} disabled={disabled}>
        {button}
      </button>

      {description && <div className={styles.description}>{description}</div>}
    </form>
  );
}

SelectMediaCode.defaultProps = {
  placeholder: undefined,
  defaultValue: undefined,
  disabled: false,
  description: undefined,
};
